import React, { useState } from 'react';
import { Card, Row, Col, Badge } from 'react-bootstrap';
import CustomLoader from '../CustomLoader';
import PropertyImagesCarousal from '../PropertyImagesCarousal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart } from '@fortawesome/free-regular-svg-icons'
import { faBed, faHeart as heartSolid, faToilet } from '@fortawesome/free-solid-svg-icons'
import PropertyModal from '../Modal/PropertyModal';
import moment from 'moment';
import Price from '../Price';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
const AllProperties = ({ allProperties }) => {
  const history = useHistory()
  const [selectedProperty, setSelectedProperty] = useState(null)
  const [isAdded, setAdded] = useState(false)
  const goToThisProperty = (slug) => {
    
    history.push(`/property/${slug}`)
  }
  const checkWhishList = (id) => {
    const ids = localStorage.getItem('whishList') ? JSON.parse(localStorage.getItem('whishList')) : [];
    for (let i = 0; i < ids.length; i++) {
      if (ids[i] === id) {
        return true
      }
    }
    return false
  }
  if (!allProperties) {
    return <CustomLoader />
  }
  return (
    <Row className='mb-4'>
      {
        React.Children.toArray(
          allProperties.map((prop) => {
            const { project_name, address, bedrooms, min, max, estimate_scs, _id, aggregatedData, property_status, property_images, bathrooms, slug } = prop
            const date = new Date(estimate_scs)
            return (
              <>
                <Col lg={6} xs={6} className='my-2'>
                  <Card className='rounded property-card position-relative'>
                    <PropertyImagesCarousal onImageClick={() => goToThisProperty(_id)} images={property_images} />
                    <div className='d-flex flex-wrap position-absolute prpnx-badge-group'>
                      {property_status ? <Badge bg="danger">{property_status.toUpperCase()}</Badge> : null}
                      {!isNaN(date.getTime()) ? <Badge bg="light" className='text-dark'>{moment(date).format('DD-MMM-YYYY')}</Badge> : null}
                    </div>
                    <Card.Body onClick={() => goToThisProperty(_id)}>
                      <Card.Title>
                        <Price min={min} max={max} />
                        <div className="d-flex justify-content-between">
                          <h6 className='nunitoFont mb-0'><strong>{project_name}</strong></h6>
                          {/* <FontAwesomeIcon icon={checkWhishList(_id) ? heartSolid : faHeart} color='#ff0000' onClick={(event) => {
                            event.stopPropagation()
                            const prevousID = JSON.parse(localStorage.getItem('whishList')) ?? []
                            const whistLitsIds = [... new Set([...prevousID, _id])]
                            setAdded(!isAdded)
                            localStorage.setItem('whishList', JSON.stringify(whistLitsIds))

                          }} /> */}
                        </div>
                      </Card.Title>
                      <Card.Text>
                        {address ? `${address.substring(0, 35)}...` : <span>---</span>}
                      </Card.Text>
                      <div className='d-flex justify-content-between prop-details'>
                        {
                          aggregatedData.bedrooms && aggregatedData.bedrooms.length > 0 ?
                            <small>
                              <FontAwesomeIcon icon={faBed} className='mx-1 text-primary ' />
                              {aggregatedData.bedrooms.length > 1 ? `${aggregatedData.bedrooms[0]} - ${aggregatedData.bedrooms[aggregatedData.bedrooms.length-1]}` : `${aggregatedData.bedrooms[0]}` } bd.
                            </small>
                            :
                            null
                        }
                        {
                          aggregatedData.bathrooms && aggregatedData.bathrooms.length > 0 ?
                            <small>
                              <FontAwesomeIcon icon={faToilet} className='mx-1 text-primary ' />
                              {aggregatedData.bathrooms.length > 1 ? `${aggregatedData.bathrooms[0]} - ${aggregatedData.bathrooms[aggregatedData.bathrooms.length-1]}` : `${aggregatedData.bathrooms[0]}` } bt.
                            </small> : null
                        }


                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </>
            )
          })
        )
      }
    </Row>
  )
};

export default AllProperties;
